exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".demo-ruleForm[data-v-0b45ccc5]{margin:20px auto 0;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0b45ccc5&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/activity/ChoiceCondition.vue
// module id = 564
// module chunks = 2